import CardTotal from "../../Component/home/CardTotal";
import OrdersCard from "../../Component/home/OrdersCard";
import ChartComponent from "../../Component/home/Chart";
import { useEffect, useState } from "react";
import apiRequests from "../../Component/axios/config/config";
import LoadingSpan from "../../Component/Loading/LoadingSpan";

export default function Dashboard() {
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    user: 0,
    product: 0,
    seller: 0,
  });

  useEffect(() => {
    setLoading(true);
    apiRequests
      .get("/api/admin/v1/Dashboard-API")
      .then((res) => {
        setData({
          user: res.data.data.user,
          product: res.data.data.product,
          seller: res.data.data.seller,
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="w-full h-[90%] flex justify-center items-center">
        <div className="flex items-center gap-1">
          <p className="pt-2 text-xl">Loading</p>
          <LoadingSpan />
        </div>
      </div>
    );
  }

  return (
    <main className="flex flex-col gap-5 p-10 justify-center">
      <section className="grid grid-cols-3 gap-x-6 md:grid-cols-2 md:gap-y-8 sm:grid-cols-1">
        <CardTotal
          type={1}
          title="Users"
          number={data.user}
          explaination="total users"
          link="/user"
        />
        <CardTotal
          type={2}
          title="Products"
          number={data.product}
          explaination="total products"
          link="/orders-product"
        />
        <CardTotal
          type={3}
          title="Sellers"
          number={data.seller}
          explaination="total sellers"
          link="/seller"
        />
      </section>

      <section className="w-full grid grid-cols-12 gap-x-6 md:grid-cols-1 md:gap-4">
        <OrdersCard dashData={data} />
        <ChartComponent />
      </section>
    </main>
  );
}
